export type ColorTheme = keyof typeof colorThemes;

export const colorThemes = {
  purple: {
    '50': '#9045af',
    '100': '#9246b1',
    '200': '#9547b6',
    '300': '#984bb8',
    '400': '#9a4fba',
    '500': '#8e44ad',
    '600': '#793a93',
    '700': '#75388f',
    '800': '#72368a',
    '900': '#6e3586',
    'alpha.100': 'rgba(142, 68, 173, 0.1)',
    'alpha.200': 'rgba(142, 68, 173, 0.2)',
    'alpha.300': 'rgba(142, 68, 173, 0.3)',
    'alpha.400': 'rgba(142, 68, 173, 0.4)',
    'alpha.500': 'rgba(142, 68, 173, 0.5)',
    'alpha.600': 'rgba(142, 68, 173, 0.6)',
    'alpha.700': 'rgba(142, 68, 173, 0.7)',
    'alpha.800': 'rgba(142, 68, 173, 0.8)',
    'alpha.900': 'rgba(142, 68, 173, 0.9)',
  },

  blue: {
    '50': '#3799dc',
    '100': '#3a9bdc',
    '200': '#409edd',
    '300': '#45a1de',
    '400': '#4ba4df',
    '500': '#3498db',
    '600': '#2383c4',
    '700': '#227fbe',
    '800': '#217bb8',
    '900': '#2078b2',
    'alpha.100': 'rgba(52, 152, 219, 0.1)',
    'alpha.200': 'rgba(52, 152, 219, 0.2)',
    'alpha.300': 'rgba(52, 152, 219, 0.3)',
    'alpha.400': 'rgba(52, 152, 219, 0.4)',
    'alpha.500': 'rgba(52, 152, 219, 0.5)',
    'alpha.600': 'rgba(52, 152, 219, 0.6)',
    'alpha.700': 'rgba(52, 152, 219, 0.7)',
    'alpha.800': 'rgba(52, 152, 219, 0.8)',
    'alpha.900': 'rgba(52, 152, 219, 0.9)',
  },

  red: {
    '900': '#6b2222',
    '800': '#7d2727',
    '700': '#8f2d2d',
    '600': '#a13333',
    '500': '#b33939',
    '400': '#c34343',
    '300': '#ca5858',
    '200': '#d06d6d',
    '100': '#d78282',
    '50': '#dd9797',

    'alpha.900': 'rgba(179, 57, 57, 0.9)',
    'alpha.800': 'rgba(179, 57, 57, 0.8)',
    'alpha.700': 'rgba(179, 57, 57, 0.7)',
    'alpha.600': 'rgba(179, 57, 57, 0.6)',
    'alpha.500': 'rgba(179, 57, 57, 0.5)',
    'alpha.400': 'rgba(179, 57, 57, 0.4)',
    'alpha.300': 'rgba(179, 57, 57, 0.3)',
    'alpha.200': 'rgba(179, 57, 57, 0.2)',
    'alpha.100': 'rgba(179, 57, 57, 0.1)',
  },

  green: {
    '50': '#2fcf72',
    '100': '#30d074',
    '200': '#35d177',
    '300': '#3ad37b',
    '400': '#3fd47e',
    '500': '#2ecc71',
    '600': '#27ad60',
    '700': '#26a85d',
    '800': '#25a35a',
    '900': '#249e58',
    'alpha.100': 'rgba(46, 204, 113, 0.1)',
    'alpha.200': 'rgba(46, 204, 113, 0.2)',
    'alpha.300': 'rgba(46, 204, 113, 0.3)',
    'alpha.400': 'rgba(46, 204, 113, 0.4)',
    'alpha.500': 'rgba(46, 204, 113, 0.5)',
    'alpha.600': 'rgba(46, 204, 113, 0.6)',
    'alpha.700': 'rgba(46, 204, 113, 0.7)',
    'alpha.800': 'rgba(46, 204, 113, 0.8)',
    'alpha.900': 'rgba(46, 204, 113, 0.9)',
  },

  orange: {
    '50': '#e68025',
    '100': '#e78128',
    '200': '#e7852e',
    '300': '#e88834',
    '400': '#e98c3a',
    '500': '#e67e22',
    '600': '#ca6b17',
    '700': '#c46816',
    '800': '#be6415',
    '900': '#b86115',
    'alpha.100': 'rgba(230, 126, 34, 0.1)',
    'alpha.200': 'rgba(230, 126, 34, 0.2)',
    'alpha.300': 'rgba(230, 126, 34, 0.3)',
    'alpha.400': 'rgba(230, 126, 34, 0.4)',
    'alpha.500': 'rgba(230, 126, 34, 0.5)',
    'alpha.600': 'rgba(230, 126, 34, 0.6)',
    'alpha.700': 'rgba(230, 126, 34, 0.7)',
    'alpha.800': 'rgba(230, 126, 34, 0.8)',
    'alpha.900': 'rgba(230, 126, 34, 0.9)',
  },

  yellow: {
    '50': '#f1c512',
    '100': '#f1c515',
    '200': '#f2c71b',
    '300': '#f2c821',
    '400': '#f2ca27',
    '500': '#f1c40f',
    '600': '#cea70c',
    '700': '#c8a20c',
    '800': '#c29d0b',
    '900': '#bb980b',
    'alpha.100': 'rgba(241, 196, 15, 0.1)',
    'alpha.200': 'rgba(241, 196, 15, 0.2)',
    'alpha.300': 'rgba(241, 196, 15, 0.3)',
    'alpha.400': 'rgba(241, 196, 15, 0.4)',
    'alpha.500': 'rgba(241, 196, 15, 0.5)',
    'alpha.600': 'rgba(241, 196, 15, 0.6)',
    'alpha.700': 'rgba(241, 196, 15, 0.7)',
    'alpha.800': 'rgba(241, 196, 15, 0.8)',
    'alpha.900': 'rgba(241, 196, 15, 0.9)',
  },
};
